import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { RequiredFieldsLabel, RadioButtons } from '@grandvisionhq/forms';
import { TitleWithIcon } from '../components/TitleWithIcon/TitleWithIcon.js';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import { StepNames } from '../models/shared.js';
import { ShippingMethods } from './modules/ShippingMethods/layouts/ShippingMethods.js';
import '@grandvisionhq/state';
import '../context/CheckoutSettings/context.js';
import '@swc/helpers';
import './selectors.js';
import '@grandvisionhq/locations';
import './modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import './modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
import '../mappers/errors-mapping.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/api-client';
import '@grandvisionhq/auth';
import '../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-store.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../utils/get-customer-details-payload.js';
import 'history';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '@grandvisionhq/shipping';
import '../state.js';
import { Consents } from '../modules/Consents/layout/Consents.js';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import { CompanyFormContainer } from './containers/CompanyFormContainer.js';
import { ContactDetailsContainer } from './containers/ContactDetailsContainer.js';
import { ImplicitAccountCreationContainer } from './containers/ImplicitAccountCreationContainer.js';
import { ImplicitTermsAndConditionsContainer } from './containers/ImplicitTermsAndConditionsContainer.js';
import { InvoiceFormContainer } from './containers/InvoiceFormContainer.js';
import { ServiceStore } from '../modules/ServiceStore/layout/ServiceStore.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { ServiceStoreHeading } from '../modules/ServiceStore/layout/ServiceStoreHeading.js';
import '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import { Footer } from '../modules/Footer/Footer.js';
import '@grandvisionhq/icons';
import 'classnames';
import '@grandvisionhq/bloomreach';
import { CustomerType } from '../types.js';
import { BillingAndDeliveryForm } from './components/AddressesSection/BillingAndDeliveryForm/Layout.js';

const StepShipping = ({ company , isCompanyEnabled , isDelivery , isDeliveryExpress , labels , onNextStep , onPrevStep , routes , shippingMethodsAsides , showLoader , toggleDeliveryAddress , toggleIsCompany , handleOptInsLoading , billingAddressForm , deliveryAddressForm , enableServiceStoreValidation =true  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--shipping"
    }, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "orders",
        label: labels.shipmentMethodTitle
    }), /*#__PURE__*/ React.createElement(ShippingMethods, {
        shippingMethodsAsides: shippingMethodsAsides
    }), /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "billing",
        label: labels.generic.title
    }), /*#__PURE__*/ React.createElement(RequiredFieldsLabel, null), isCompanyEnabled && /*#__PURE__*/ React.createElement(RadioButtons, {
        scope: "orderType",
        alignment: "horizontal",
        onChange: toggleIsCompany,
        initialValue: company ? CustomerType.Company : CustomerType.Private,
        items: [
            {
                value: CustomerType.Private,
                label: labels.customerType.private
            },
            {
                value: CustomerType.Company,
                label: labels.customerType.company
            }, 
        ]
    }), /*#__PURE__*/ React.createElement(CompanyFormContainer, null), showLoader ? /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step--shipping__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, {
        billingAddressForm: billingAddressForm,
        deliveryAddressForm: deliveryAddressForm,
        onToggleDeliveryAddress: toggleDeliveryAddress,
        isDelivery: isDelivery,
        isDeliveryExpress: isDeliveryExpress
    }), /*#__PURE__*/ React.createElement(ContactDetailsContainer, null), /*#__PURE__*/ React.createElement(InvoiceFormContainer, null), /*#__PURE__*/ React.createElement(ServiceStoreHeading, {
        hideIcon: false,
        title: labels.serviceStoreTitle,
        subtitle: labels.serviceStoreSubtitle,
        showAsteriksSignInSubTitle: enableServiceStoreValidation
    }), /*#__PURE__*/ React.createElement(ServiceStore, null)), /*#__PURE__*/ React.createElement(Consents, {
        handleOptInsLoading: handleOptInsLoading
    }), /*#__PURE__*/ React.createElement(ImplicitTermsAndConditionsContainer, null), /*#__PURE__*/ React.createElement(Footer, {
        stepName: StepNames.Shipping,
        nextStepDisabled: false,
        onPrevStep: onPrevStep,
        onNextStep: onNextStep,
        isFirstStep: Object.keys(routes !== null && routes !== void 0 ? routes : {})[0] === StepNames.Shipping
    }), /*#__PURE__*/ React.createElement(ImplicitAccountCreationContainer, null));
};

export { StepShipping };
//# sourceMappingURL=StepShipping.js.map
